import { AlertDialogProvider } from '@fukuri-admins/ui/common/AlertDialog';
import { NotFound } from '@fukuri-admins/ui/common/errors';
import { ToastProvider } from '@fukuri-admins/ui/common/Toast/provider';
import { TooltipProvider } from '@fukuri-admins/ui/common/Tooltip/provider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { StressAssessmentRoleRoute } from './components/auth/StressAssessmentRoleRoute';
import { DashboardLayout } from './components/layouts/DashboardLayout';
import { ConfigurationProvider } from './contexts/ConfigurationProvider';
import { Admins } from './pages/Admins';
import { AdminEdit } from './pages/Admins/[id]/edit';
import { AdminsNew } from './pages/Admins/new';
import { Branches } from './pages/Branches';
import { BranchEdit } from './pages/Branches/[id]/edit';
import { BranchesNew } from './pages/Branches/new';
import { Contact } from './pages/Contact';
import { ContractInfo } from './pages/contract-info';
import { InternalNews } from './pages/InternalNews';
import { InternalNewsEdit } from './pages/InternalNews/[id]/edit';
import { InternalNewsDetail } from './pages/InternalNews/[id]/index';
import { InternalNewsNew } from './pages/InternalNews/new';
import { LegacyPendingUser } from './pages/LegacyPendingUser';
import { Login } from './pages/Login';
import { LoginReport } from './pages/LoginReport/Index';
import { PendingUser } from './pages/PendingUser';
import { Portal } from './pages/Portal';
import { Root } from './pages/Root';
import { ServiceReport } from './pages/ServiceReport';
import { StressAssessments } from './pages/StressAssessments';
import { StressAssessmentsReports } from './pages/StressAssessments/[id]/reports';
import { StressAssessmentsReportsDownload } from './pages/StressAssessments/[id]/reportsDownload';
import { StressAssessmentsNew } from './pages/StressAssessments/new';
import { StressAssessmentsRoleSelect } from './pages/StressAssessments/role-select';
import { StressAssessmentsSchedule } from './pages/StressAssessments/schedule';
import { StressAssessmentsUserResult } from './pages/StressAssessments/UserResult';
import { IndexUser } from './pages/users';
import { UserDetail } from './pages/users/[id]';
import { UserEdit } from './pages/users/[id]/edit';
import { UserNew } from './pages/users/new';
import { getEnvFeatureFlag } from './utils/getEnvFeatureFlag';
import { ROUTES } from './utils/routes';

function App() {
  const { enableStaging } = getEnvFeatureFlag();
  return (
    <BrowserRouter>
      <ToastProvider>
        <TooltipProvider>
          <AuthProvider>
            <AlertDialogProvider>
              <ConfigurationProvider>
                <Routes>
                  <Route path={ROUTES.LOGIN} element={<Login />} />
                  <Route element={<ProtectedRoute />}>
                    <Route element={<DashboardLayout />}>
                      {!enableStaging && (
                        <Route path={ROUTES.PENDING_USERS} element={<LegacyPendingUser />} />
                      )}
                      <Route path={ROUTES.SERVICE_REPORT} element={<ServiceReport />} />
                      <Route path={ROUTES.LOGIN_REPORT} element={<LoginReport />} />
                      <Route path={ROUTES.CONTACT} element={<Contact />} />
                    </Route>
                    <Route path={ROUTES.ROOT} element={<Root />} />
                    {enableStaging && (
                      <Route path={ROUTES.PENDING_USERS} element={<PendingUser />} />
                    )}
                    <Route path={ROUTES.USER_SHOW} element={<UserDetail />} />
                    <Route path={ROUTES.USER_EDIT} element={<UserEdit />} />
                    <Route path={ROUTES.USER_NEW} element={<UserNew />} />
                    <Route path={ROUTES.ADMINS.INDEX} element={<Admins />} />
                    {enableStaging && <Route path={ROUTES.ADMINS.NEW} element={<AdminsNew />} />}
                    {enableStaging && <Route path={ROUTES.ADMINS.EDIT} element={<AdminEdit />} />}
                    <Route element={<StressAssessmentRoleRoute />}>
                      <Route
                        path={ROUTES.STRESS_ASSESSMENTS.INDEX}
                        element={<StressAssessments />}
                      />
                      <Route
                        path={ROUTES.STRESS_ASSESSMENTS.NEW}
                        element={<StressAssessmentsNew />}
                      />
                      <Route
                        path={ROUTES.STRESS_ASSESSMENTS.REPORTS}
                        element={<StressAssessmentsReports />}
                      />
                      <Route
                        path={ROUTES.STRESS_ASSESSMENTS.USER_RESULT}
                        element={<StressAssessmentsUserResult />}
                      />
                      <Route
                        path={ROUTES.STRESS_ASSESSMENTS.REPORTS_DOWNLOAD}
                        element={<StressAssessmentsReportsDownload />}
                      />
                      <Route
                        path={ROUTES.STRESS_ASSESSMENTS.SCHEDULE}
                        element={<StressAssessmentsSchedule />}
                      />
                    </Route>
                    <Route
                      path={ROUTES.STRESS_ASSESSMENTS.ROLE_SELECT}
                      element={<StressAssessmentsRoleSelect />}
                    />
                    <Route path={ROUTES.BRANCHES.INDEX} element={<Branches />} />
                    <Route path={ROUTES.BRANCHES.NEW} element={<BranchesNew />} />
                    <Route path={ROUTES.BRANCHES.EDIT} element={<BranchEdit />} />
                    <Route path={ROUTES.USERS} element={<IndexUser />} />
                    <Route path={ROUTES.INTERNAL_NEWS.INDEX} element={<InternalNews />} />
                    <Route path={ROUTES.INTERNAL_NEWS.NEW} element={<InternalNewsNew />} />
                    <Route path={ROUTES.INTERNAL_NEWS.EDIT} element={<InternalNewsEdit />} />
                    <Route path={ROUTES.INTERNAL_NEWS.DETAIL} element={<InternalNewsDetail />} />
                    <Route path={ROUTES.PORTAL} element={<Portal />} />
                    <Route path={ROUTES.PORTAL} element={<Portal />} />
                    {enableStaging && (
                      <Route path={ROUTES.CONTRACT_INFO} element={<ContractInfo />} />
                    )}
                  </Route>
                  <Route path='*' element={<NotFound />} />
                </Routes>
              </ConfigurationProvider>
            </AlertDialogProvider>
          </AuthProvider>
        </TooltipProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
